import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from "vue";
import { trans, isLoaded } from "laravel-vue-i18n";
import { useAuthStore } from "@/ts/stores/auth";


export default /*#__PURE__*/_defineComponent({
  emits: ["cancel", "renew", "mounted"],
  setup(__props, { expose, emit }) {
  expose();

const authStore = useAuthStore();
const component = ref<HTMLDivElement>();



onMounted(() => {
    emit("mounted", component.value!.offsetHeight);

    let translationsChecker = setInterval(() => {
        if (isLoaded()) {
            emitComponentHeight();
            clearInterval(translationsChecker);
        }
    }, 50);

    window.addEventListener("resize", () => {
        emitComponentHeight();
    });

    window.addEventListener("orientationchange", () => {
        emitComponentHeight();
    });
});

function emitComponentHeight() {
    if (component.value) {
        emit("mounted", component.value!.offsetHeight);
    }
}

const __returned__ = { authStore, component, emit, emitComponentHeight, trans }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})